import { useCallback, useState } from 'react';

export type PaginationModel = {
  page?: number;
  pageSize?: number;
};

export const usePagination = (
  { page = 0, pageSize = 10 }: PaginationModel = {
    page: 0,
    pageSize: 15,
  }
) => {
  const [paginationModel, setPaginationModel] = useState({
    page,
    pageSize,
  });

  const getPaginationQueryString = useCallback(() => {
    const queryParams = new URLSearchParams({
      page: (paginationModel.page + 1).toString(),
      pageSize: paginationModel.pageSize.toString(),
    });
    return queryParams.toString();
  }, [paginationModel.page, paginationModel.pageSize]);

  return {
    getPaginationQueryString,
    paginationModel,
    setPaginationModel,
  };
};
